import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ContactsCreateFromEmailSync as ContactsCreateFromEmailSyncMutation,
    ContactsCreateFromEmailSyncVariables,
    ContactsCreateFromEmailSyncInput,
} from 'nutshell-graphql-types';

import CONTACTS_CREATE_FROM_EMAIL_SYNC from '../mutations/contacts-create-from-email-sync.graphql';

export const useContactsCreateFromEmailSync = (): {
    contactsCreateFromEmailSync: (input: ContactsCreateFromEmailSyncInput[]) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [contactsCreateFromEmailSync, {loading, error}] = useMutation<
        ContactsCreateFromEmailSyncMutation,
        ContactsCreateFromEmailSyncVariables
    >(CONTACTS_CREATE_FROM_EMAIL_SYNC);

    return {
        contactsCreateFromEmailSync: (input: ContactsCreateFromEmailSyncInput[]) =>
            contactsCreateFromEmailSync({
                variables: {input},
            }),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
